import React from "react";
import styles from "./BlackFridayForth.module.scss";

export default function BlackFridayForth() {
  return (
    <div className="col-12 g-0 d-flex justify-content-center gap-2 flex-column flex-md-row align-items-center bg-black py-1 px-2">
      <img src="/img/BF-banner.webp" alt="black friday banner" className={`${styles.img} img-fluid`} />
      <p className={`mb-0 text-white fw-semibold d-flex align-items-center gap-2`}>
        <span className={styles.goldText}>20% OFF Tests over £79</span>
      </p>
    </div>
  );
}
